import React from "react";
import ReactDOM from "react-dom";

import MyApp from "./App";

ReactDOM.render(<MyApp />, document.getElementById("root"));
